import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { CommercialService } from '../../commercial.service';
import { _ } from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group,
} from '@angular/animations';

@Component({
  selector: 'app-cq8',
  templateUrl: './cq8.component.html',
  styleUrls: [
    './cq8.component.css',
    '../commercial-questionnaire.component.css',
  ],
  animations: [
    trigger('flyInOut', [
      state(
        'in',
        style({
          transform: 'translateX(0)',
          opacity: 1,
        })
      ),
      transition('void => *', [
        style({ transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate(
            '0.4s 0.1s ease',
            style({
              transform: 'translateX(0)',
            })
          ),
          animate(
            '0.4s ease',
            style({
              opacity: 1,
            })
          ),
        ]),
      ]),
      transition('* => void', [
        group([
          animate(
            '0.4s ease',
            style({
              transform: 'translateX(50px)',
            })
          ),
          animate(
            '0.4s 0.2s ease',
            style({
              opacity: 0,
            })
          ),
        ]),
      ]),
    ]),
  ],
})
export class Cq8Component implements OnInit {
  @Input() data: any;
  questions = [];
  userResponses = [];
  question;
  questionObj;
  user_bot = false;
  deviceWidth;
  question_sub1;
  question_sub2;
  question_sub3;
  hgInvestments = {
    investment1: false,
    investment2: false,
    investment3: false,
    investment4: false,
    investment5: false,
    investment6: false,
  };
  investments = [];
  investment1_id;
  investment2_id;
  investment3_id;
  investment4_id;
  investment5_id;
  investment6_id;
  time = 0;
  timer;
  typingTimer;
  showTyping = false;
  isDisable = false;
  location_investments = [];
  showTip = false;
  other;
  @ViewChild('Oth', { static: true }) otherEl: ElementRef;
  @ViewChild('Oth_mob', { static: true }) otherEl_mob: ElementRef;
  @ViewChild('myInput', { static: true }) input: ElementRef;

  constructor(private commercialService: CommercialService) {
    this.questions = this.commercialService.getQues();
    this.deviceWidth = this.commercialService.deviceWidth;
    this.userResponses = this.commercialService.userResponse.userResponses;
  }

  myInputFocus() {
    if (this.investment6_id.checked === false) {
      this.other = '';
    } else if (this.investment6_id.checked) {
      this.input.nativeElement.focus();
    }
  }

  ngOnInit() {
    this.commercialService.currentId = this.data;
    if (this.deviceWidth < 768) {
      this.investment1_id = document.getElementById('investment1_mob');
      this.investment2_id = document.getElementById('investment2_mob');
      this.investment3_id = document.getElementById('investment3_mob');
      this.investment4_id = document.getElementById('investment4_mob');
      this.investment5_id = document.getElementById('investment5_mob');
      this.investment6_id = document.getElementById('investment6_mob');
    } else {
      this.investment1_id = document.getElementById('investment1');
      this.investment2_id = document.getElementById('investment2');
      this.investment3_id = document.getElementById('investment3');
      this.investment4_id = document.getElementById('investment4');
      this.investment5_id = document.getElementById('investment5');
      this.investment6_id = document.getElementById('investment6');
    }
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].com_question;
        this.questionObj = this.questions[i];
        if (this.deviceWidth > 768) {
          const question_sub1 = this.question.split('made ');
          this.question_sub1 = question_sub1[0] + 'made';
          this.question_sub2 = question_sub1[1];
        }
      }
    }
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, {
        com_question_id: this.questionObj._id,
      });
      if (!_.isEmpty(obj)) {
        this.location_investments = obj.fieldValue;
        if (
          !this.commercialService.addAddress &&
          !_.isEmpty(this.location_investments)
        ) {
          let index;
          if (this.commercialService.serialNumber !== null) {
            index = this.commercialService.serialNumber;
          } else if (this.commercialService.serialNumber === null) {
            index = 0;
          }
          if (!_.isEmpty(this.location_investments[index])) {
            this.investments = this.location_investments[index].value;
            for (let i = 0; i < this.investments.length; i++) {
              if (
                this.investments[i] === 'LEDs, lighting controls or sensors'
              ) {
                this.hgInvestments.investment1 = true;
                this.investment1_id.parentElement.classList.add(
                  'active-select'
                );
              } else if (
                this.investments[i] === 'HVAC & refrigeration controls'
              ) {
                this.hgInvestments.investment2 = true;
                this.investment2_id.parentElement.classList.add(
                  'active-select'
                );
              } else if (this.investments[i] === 'Demand management') {
                this.hgInvestments.investment3 = true;
                this.investment3_id.parentElement.classList.add(
                  'active-select'
                );
              } else if (this.investments[i] === 'Building automation') {
                this.hgInvestments.investment4 = true;
                this.investment4_id.parentElement.classList.add(
                  'active-select'
                );
              } else if (this.investments[i] === 'Window technology') {
                this.hgInvestments.investment5 = true;
                this.investment5_id.parentElement.classList.add(
                  'active-select'
                );
              } else if (this.investments[i].value === 'Other') {
                this.hgInvestments.investment6 = true;
                this.other = this.investments[i].input;
                if (this.deviceWidth < 768) {
                  this.investment6_id.parentElement.classList.add(
                    'active-select'
                  );
                } else {
                  this.investment6_id.parentElement.parentElement.classList.add(
                    'active-select'
                  );
                }
              }
            }
            this.user_bot = true;
            this.showTip = true;
            if (this.deviceWidth < 768) {
              this.showTyping = true;
              setTimeout(() => {
                this.showTyping = false;
                this.next();
              }, this.time);
            }
          }
        }
      }
    }
  }

  getHg_investment(hg_investment_option, value) {
    if (this.deviceWidth < 768) {
      this.commercialService.unSelectService({ currentId: this.data });
    }
    if (
      hg_investment_option === 'LEDs, lighting controls or sensors' &&
      value === true
    ) {
      this.investments.push(hg_investment_option);
      this.investment1_id.parentElement.classList.add('active-select');
    } else if (
      hg_investment_option === 'LEDs, lighting controls or sensors' &&
      value === false
    ) {
      if (!_.isEmpty(this.investments)) {
        const index = this.investments.indexOf(hg_investment_option);
        this.investments.splice(index, 1);
        this.investment1_id.parentElement.classList.remove('active-select');
      }
    } else if (
      hg_investment_option === 'HVAC & refrigeration controls' &&
      value === true
    ) {
      this.investments.push(hg_investment_option);
      this.investment2_id.parentElement.classList.add('active-select');
    } else if (
      hg_investment_option === 'HVAC & refrigeration controls' &&
      value === false
    ) {
      if (!_.isEmpty(this.investments)) {
        const index = this.investments.indexOf(hg_investment_option);
        this.investments.splice(index, 1);
        this.investment2_id.parentElement.classList.remove('active-select');
      }
    } else if (hg_investment_option === 'Demand management' && value === true) {
      this.investments.push(hg_investment_option);
      this.investment3_id.parentElement.classList.add('active-select');
    } else if (
      hg_investment_option === 'Demand management' &&
      value === false
    ) {
      if (!_.isEmpty(this.investments)) {
        const index = this.investments.indexOf(hg_investment_option);
        this.investments.splice(index, 1);
        this.investment3_id.parentElement.classList.remove('active-select');
      }
    } else if (
      hg_investment_option === 'Building automation' &&
      value === true
    ) {
      this.investments.push(hg_investment_option);
      this.investment4_id.parentElement.classList.add('active-select');
    } else if (
      hg_investment_option === 'Building automation' &&
      value === false
    ) {
      if (!_.isEmpty(this.investments)) {
        const index = this.investments.indexOf(hg_investment_option);
        this.investments.splice(index, 1);
        this.investment4_id.parentElement.classList.remove('active-select');
      }
    } else if (hg_investment_option === 'Window technology' && value === true) {
      this.investments.push(hg_investment_option);
      this.investment5_id.parentElement.classList.add('active-select');
    } else if (
      hg_investment_option === 'Window technology' &&
      value === false
    ) {
      if (!_.isEmpty(this.investments)) {
        const index = this.investments.indexOf(hg_investment_option);
        this.investments.splice(index, 1);
        this.investment5_id.parentElement.classList.remove('active-select');
      }
    } else if (hg_investment_option === 'Other' && value === true) {
      this.investments.push({ value: 'Other', input: this.other });
      if (this.deviceWidth < 768) {
        this.investment6_id.parentElement.classList.add('active-select');
      } else {
        this.investment6_id.parentElement.parentElement.classList.add(
          'active-select'
        );
      }
    } else if (hg_investment_option === 'Other' && value === false) {
      if (!_.isEmpty(this.investments)) {
        const index = this.investments.indexOf(hg_investment_option);
        this.investments.splice(index, 1);
        if (this.deviceWidth < 768) {
          this.investment6_id.parentElement.classList.remove('active-select');
        } else {
          this.investment6_id.parentElement.parentElement.classList.remove(
            'active-select'
          );
        }
      }
    }
    if (_.isEmpty(this.investments)) {
      this.user_bot = false;
      this.showTip = false;
      if (this.deviceWidth < 768) {
        this.commercialService.unSelectService({ currentId: this.data });
      }
    } else {
      if (hg_investment_option === 'Other' && value === true) {
        this.showTip = true;
        this.user_bot = true;
        this.time = 3000;
        this.goNext();
      } else {
        this.showTip = true;
        this.user_bot = true;
        this.time = 3000;
        this.goNext();
      }
    }
  }

  getOther() {
    if (!_.isEmpty(this.other) && this.hgInvestments.investment6) {
      if (this.deviceWidth < 768) {
        this.commercialService.unSelectService({ currentId: this.data });
      }
      this.user_bot = true;
      this.update({ value: 'Other', input: this.other });
      this.goNext();
    } else if (!_.isEmpty(this.other) && !this.hgInvestments.investment6) {
      if (this.deviceWidth < 768) {
        this.commercialService.unSelectService({ currentId: this.data });
      }
      this.hgInvestments.investment6 = true;
      this.update({ value: 'Other', input: this.other });
      this.user_bot = true;
      if (this.deviceWidth < 768) {
        this.otherEl_mob.nativeElement.blur();
      }
      this.goNext();
    } else if (_.isEmpty(this.other)) {
      this.user_bot = false;
      if (this.deviceWidth < 768) {
        this.commercialService.unSelectService({ currentId: this.data });
      }
    }
  }

  public update(response) {
    const foundElem = _.findWhere(this.investments, { value: 'Other' });
    if (foundElem === undefined) {
      this.investments.push(response);
    } else {
      this.investments = _.map(this.investments, function (item, index) {
        if (item && response && item.value === 'Other') {
          item = response;
        }
        return item;
      });
    }
  }

  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      if (this.typingTimer) {
        clearTimeout(this.typingTimer);
        this.showTyping = false;
      }
      this.typingTimer = setTimeout(() => {
        this.showTyping = true;
      }, 250);
      this.timer = setTimeout(() => {
        // // console.log.log(this.time);
        this.showTyping = false;
        this.next();
      }, this.time);
      this.showTyping = false;
    }
  }

  next() {
    if (_.isEmpty(this.investments) || !this.user_bot) {
      this.commercialService.unSelectService({ currentId: this.data });
    } else {
      this.save();
      this.commercialService.messageService({ currentId: this.data });
    }
  }
  // This function is used for to save the data in DB
  save() {
    let index;
    if (this.commercialService.serialNumber === null) {
      index = this.location_investments.length;
    } else {
      index = this.commercialService.serialNumber;
    }
    this.location_investments[index] = {
      serialNo: index + 1,
      value: this.investments,
    };
    const Obj = {
      com_question_id: this.data,
      fieldName: 'investments',
      fieldValue: this.location_investments,
    };
    this.commercialService.updateResponses(Obj);
  }
}
